// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"ffe40b6d","845":"d7a1484e"}[chunkId] + ".chunk.js";
};